import { BgSvg } from "assets/images/icons";

export default function BackgroundWrapper({ children }: any) {
  return (
    <div className="relative w-full h-full bg-cover">
        <BgSvg/>
      <div className="absolute inset-0 bg-opacity-40 z-0" />
      <div className="relative z-10 h-full">{children}</div>
    </div>
  );
}